type RawSql = (query: string, params?: unknown[]) => Promise<unknown>;

export async function ensurePlatformActivityEventsSchema(params: { rawSql: RawSql }): Promise<void> {
  await params.rawSql(`CREATE TABLE IF NOT EXISTS platform_activity_events (
            id BIGSERIAL PRIMARY KEY,
            event_id TEXT NOT NULL UNIQUE,
            occurred_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
            received_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
            category TEXT NOT NULL,
            action TEXT NOT NULL,
            outcome TEXT NOT NULL,
            severity TEXT NOT NULL DEFAULT 'info',
            actor_type TEXT NOT NULL,
            actor_user_id TEXT,
            actor_role TEXT,
            actor_session_id_hash TEXT,
            actor_token_id TEXT,
            target_type TEXT,
            target_id TEXT,
            target_owner_user_id TEXT,
            app_id INTEGER,
            app_name TEXT,
            environment TEXT,
            deploy_id INTEGER,
            request_id TEXT,
            source TEXT NOT NULL,
            ip_hash TEXT,
            user_agent_hash TEXT,
            country TEXT,
            reason_code TEXT,
            metadata_json JSONB NOT NULL DEFAULT '{}'::jsonb,
            search_text TEXT NOT NULL DEFAULT '',
            actor_user_snapshot_json JSONB NOT NULL DEFAULT '{}'::jsonb,
            target_user_snapshot_json JSONB NOT NULL DEFAULT '{}'::jsonb,
            app_snapshot_json JSONB NOT NULL DEFAULT '{}'::jsonb,
            request_context_json JSONB NOT NULL DEFAULT '{}'::jsonb,
            auth_attempt_json JSONB NOT NULL DEFAULT '{}'::jsonb,
            deploy_context_json JSONB NOT NULL DEFAULT '{}'::jsonb,
            context_status TEXT NOT NULL DEFAULT 'legacy_partial',
            actor_email TEXT,
            actor_email_hash TEXT,
            target_user_email TEXT,
            target_user_email_hash TEXT,
            attempted_email TEXT,
            attempted_email_hash TEXT,
            owner_email TEXT,
            owner_email_hash TEXT,
            app_owner_user_id TEXT,
            route_path TEXT,
            http_method TEXT,
            http_status INTEGER
        )`);
  const columnStatements = [
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS actor_user_snapshot_json JSONB NOT NULL DEFAULT '{}'::jsonb`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS target_user_snapshot_json JSONB NOT NULL DEFAULT '{}'::jsonb`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS app_snapshot_json JSONB NOT NULL DEFAULT '{}'::jsonb`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS request_context_json JSONB NOT NULL DEFAULT '{}'::jsonb`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS auth_attempt_json JSONB NOT NULL DEFAULT '{}'::jsonb`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS deploy_context_json JSONB NOT NULL DEFAULT '{}'::jsonb`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS context_status TEXT NOT NULL DEFAULT 'legacy_partial'`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS actor_email TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS actor_email_hash TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS target_user_email TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS target_user_email_hash TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS attempted_email TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS attempted_email_hash TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS owner_email TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS owner_email_hash TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS app_owner_user_id TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS route_path TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS http_method TEXT`,
    `ALTER TABLE platform_activity_events ADD COLUMN IF NOT EXISTS http_status INTEGER`,
  ];
  for (const statement of columnStatements) await params.rawSql(statement);
  await params.rawSql(
    `CREATE UNIQUE INDEX IF NOT EXISTS platform_activity_events_event_id_key ON platform_activity_events (event_id)`,
  );
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS idx_platform_activity_actor_time ON platform_activity_events (actor_user_id, occurred_at DESC)`,
  );
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS idx_platform_activity_app_time ON platform_activity_events (app_id, occurred_at DESC)`,
  );
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS idx_platform_activity_action_time ON platform_activity_events (category, action, outcome, occurred_at DESC)`,
  );
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS idx_platform_activity_target_time ON platform_activity_events (target_type, target_id, occurred_at DESC)`,
  );
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS idx_platform_activity_request_id ON platform_activity_events (request_id)`,
  );
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS idx_platform_activity_metadata ON platform_activity_events USING GIN (metadata_json)`,
  );
  await params.rawSql(`CREATE INDEX IF NOT EXISTS idx_platform_activity_actor_email ON platform_activity_events (actor_email)`);
  await params.rawSql(`CREATE INDEX IF NOT EXISTS idx_platform_activity_target_email ON platform_activity_events (target_user_email)`);
  await params.rawSql(`CREATE INDEX IF NOT EXISTS idx_platform_activity_attempted_email ON platform_activity_events (attempted_email)`);
  await params.rawSql(`CREATE INDEX IF NOT EXISTS idx_platform_activity_owner_email ON platform_activity_events (owner_email)`);
  await params.rawSql(`CREATE INDEX IF NOT EXISTS idx_platform_activity_app_owner ON platform_activity_events (app_owner_user_id, occurred_at DESC)`);
  await params.rawSql(`CREATE INDEX IF NOT EXISTS idx_platform_activity_route_path ON platform_activity_events (route_path)`);
  await params.rawSql(`CREATE INDEX IF NOT EXISTS idx_platform_activity_deploy_time ON platform_activity_events (deploy_id, occurred_at DESC)`);
}
